<template>
  <v-row>
    <v-card flat tile width="100%" :color="pt_item.trash ? 'error lighten-5' : ''">
      <template v-if="rate.price.price > 0.0">
        <v-row no-gutters>
          <v-col class="d-flex justify-start">
            <v-chip
              x-small
              label
              color="teal darken-3"
              dark
              class="px-1 font-weight-bold chip-x-small-custom"
              >{{ rate.currency }}</v-chip
            >
          </v-col>
          <v-col class="d-flex justify-end">
            <v-chip
              x-small
              label
              color="blue-grey"
              dark
              class="px-1 font-weight-bold chip-x-small-custom"
              >{{ rate.uom }}</v-chip
            >
          </v-col>
        </v-row>

        <v-row justify="center" :class="display == 'supplier' ? 'mt-1' : 'mt-n1'">
          <span
            class="price-text font-weight-bold secondary--text"
            :style="display == 'supplier' ? 'cursor: pointer;' : ''"
            @click="onUpdateRate"
            >{{ rate.price.price.toFixed(2) }}</span
          >
        </v-row>

        <v-row justify="center" v-show="display != 'supplier'">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="cost-text font-weight-bold error--text">{{
                rate.average_cost.toFixed(2)
              }}</span>
            </template>
            Average cost
          </v-tooltip>
        </v-row>

        <v-row no-gutters justify="space-between" v-show="display != 'supplier'">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                class="cost-text font-weight-bold accent--text text--darken-1 mr-1"
                >{{ rate.lowest_cost.cost.toFixed(2) }}</span
              >
            </template>
            <!-- {{suppliers[rate.lowest_cost.supplier_id].short_name}} -->
            Lowest cost
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="cost-text font-weight-bold primary--text ml-1">{{
                rate.highest_cost.cost.toFixed(2)
              }}</span>
            </template>
            <!-- {{suppliers[rate.highest_cost.supplier_id].short_name}} -->
            Highest cost
          </v-tooltip>
        </v-row>

        <v-row no-gutters>
          <v-col class="d-flex justify-start" align-self="end">
            <v-chip
              v-if="rate.price.min_price > 0.0"
              x-small
              label
              color="accent"
              dark
              class="px-1 font-weight-bold chip-x-small-custom"
              >min</v-chip
            >
          </v-col>

          <v-col class="d-flex justify-end" align-self="end">
            <v-icon
              v-show="display == 'supplier'"
              size="15"
              color="error"
              class="px-0"
              @click="onDeleteRate"
              >mdi-delete</v-icon
            >
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row
          justify="center"
          align="center"
          class="fill-height"
          :style="display == 'supplier' ? 'cursor: pointer;' : ''"
          @click="onUpdateRate"
        >
          <span class="overline grey--text font-weight-bold">N/A</span>
        </v-row>
      </template>
    </v-card>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: ["ptItem", "rates", "display"],

  data() {
    return {
      pt_item: this.ptItem,
      rate: this.rates,
    };
  },
  created() {},
  mounted() {},
  watch: {
    ptItem() {
      this.pt_item = this.ptItem;
    },
    rates() {
      this.rate = this.rates;
    },
  },
  methods: {
    /**
     * Emit update rate
     */
    onUpdateRate() {
      this.$emit("update-rate", this.pt_item, this.rate);
    },

    /**
     * Emit delete rate
     */
    onDeleteRate() {
      this.$emit("delete-rate", this.rate);
    },
  },
  computed: {},
};
</script>

<style scoped>
.v-chip.v-size--x-small.chip-x-small-custom {
  font-size: 9px;
  height: 12px;
}

.price-text {
  font-size: 11.5px;
}

.cost-text {
  /* font-size: .625rem!important; */
  font-size: 0.6243rem !important;
  /* font-size: 9.9px!important; */
  font-weight: 200;
  letter-spacing: 0.01rem !important;
  line-height: normal;
  font-family: Roboto, sans-serif !important;
}
</style>
